<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>运营中心</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="isHideDetails = false">项目日报</a>
      </a-breadcrumb-item>
      <!-- <a-breadcrumb-item>总报表</a-breadcrumb-item> -->
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!isHideDetails">
      <section class="searchBox">
        <span>
          <a-button v-show="!showIsSearch" @click="showIsSearch = true"
            >显示更多</a-button
          >
          <a-button v-show="showIsSearch" @click="showIsSearch = false"
            >隐藏更多</a-button
          ></span
        >
        <span v-show="showIsSearch">
          <label>行业：</label>
          <a-select
            v-model="trade_id"
            placeholder="请选择行业类型"
            style="width: 160px"
          >
            <a-select-option
              v-for="(item, i) in tradeList"
              :key="i"
              :value="item.id"
              >{{ item.trade_name }}</a-select-option
            >
          </a-select>
        </span>
        <span v-show="showIsSearch">
          <label>一级项目：</label>
          <a-select
            showSearch
            :filterOption="filterOption"
            v-model="selectedOneVal"
            @change="selectedOne"
            placeholder="请选择项目"
            style="width: 160px"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in proListOne"
              :key="i"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span v-show="isShowTwo && showIsSearch">
          <label>省级项目：</label>
          <a-select
            v-model="selectedTwoVal"
            @change="selectedTwo"
            showSearch
            :filterOption="filterOption"
            placeholder="请选择项目"
            style="width: 160px"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in proListTwo"
              :key="i"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>项目：</label>
          <a-select
            v-model="selectedThreeVal"
            showSearch
            :filterOption="filterOption"
            placeholder="请选择项目"
            style="width: 160px"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in proListThree"
              :key="i"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span v-show="showIsSearch">
          <label>日期：</label>
          <a-range-picker
            v-model="date"
            :placeholder="['开始时间', '结束时间']"
            @change="onChangeDate"
          />
        </span>
        <span>
          <label>字符串：</label>
          <div>
            <a-input placeholder="请输入项目|省份|城市" v-model="query_field" />
          </div>
        </span>
        <span>
          <a-button style="margin-right: 10px" @click="onReset">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
          <a-button class="resetStyle" @click="downloadDaily">
            <a-icon type="vertical-align-bottom" />在职人数下载
          </a-button>
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data == ''">
              <td></td>
              <td></td>
              <td></td>
              <td>--- 暂无 ---</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data != ''">
              <td>合计</td>
              <td>{{ count_data.total_resume }}</td>
              <td>{{ count_data.total_resume_assigned }}</td>
              <td>{{ count_data.total_resume_task }}</td>
              <td>{{ count_data.total_no_resume_task }}</td>
              <td>{{ count_data.total_entry }}</td>
              <td>{{ count_data.total_leave }}</td>
            </tr>
            <tr v-show="data != ''" v-for="(item, i) in data" :key="i">
              <td>{{ item.project_name }}</td>
              <td>
                {{ item.total_resume == 0 ? "--" : item.total_resume }}
              </td>
              <td>
                {{
                  item.total_resume_task == 0 ? "--" : item.total_resume_task
                }}
              </td>
              <td>
                {{
                  item.total_resume_task == 0 ? "--" : item.total_resume_task
                }}
              </td>
              <td>
                {{
                  item.total_no_resume_task == 0
                    ? "--"
                    : item.total_no_resume_task
                }}
              </td>
              <td>
                {{ item.total_entry == 0 ? "--" : item.total_entry }}
              </td>
              <td>
                {{ item.total_leave == 0 ? "--" : item.total_leave }}
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- 详情 -->
    <operationDailyDetail v-show="isHideDetails" :details="details" />
    <!-- 详情 end -->
  </div>
</template>
<script>
import axios from "axios";
import operationDailyDetail from "@/components/management/operationDailyDetail";
export default {
  data() {
    return {
      data: [],
      loading: false,
      page: 1,
      pagination: {},
      thList: [
        "项目",
        "新增资源数",
        "邀约数量",
        "带面任务",
        "未完成带面任务",
        "在职",
        "离职"
      ],
      isHideDetails: false,
      details: {},
      query_field: "",
      searchDate: "",
      projectList: [],
      employee_type: 0,
      date: null,
      count_data: "",
      proListOne: [],
      proListTwo: [],
      proListThree: [],
      isShowTwo: false,
      selectedOneVal: "",
      selectedTwoVal: "",
      selectedThreeVal: "",
      tradeList: [],
      departmentList: [],
      trade_id: "",
      department_id: "",
      role_ids: [],
      roleList: [],
      showIsSearch: false
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    this.getData(); //获取列表
    this.getPro(); //获取项目列表
    this.getProOne(); //获取一级项目列表
    this.getTrade(); //获取行业
  },
  components: {
    operationDailyDetail
  },
  methods: {
    downloadDaily() {
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/downloadOnJob?token=" +
        window.localStorage.getItem("xnwfPcToken");
    },
    getTrade() {
      let url = this.httpsBasic.url + this.httpsBasic.trade + "Trade/tradeList";
      //   console.log(url)
      let pramas = {
        token: window.localStorage.getItem("xnwfPcToken"),
        current_page: 1,
        per_page: 1000
      };
      axios.post(url, pramas).then(res => {
        if (res.data.code == 200) {
          this.tradeList = res.data.data.data;
        }
        // console.log(res);
      });
    },
    selectedOne(id) {
      this.isShowTwo = true;
      this.selectedTwoVal = "";
      this.selectedThreeVal = "";
      this.getProID(id, 1); //获取下级项目
      // console.log(id);
    },
    selectedTwo(id) {
      this.selectedThreeVal = "";
      this.getProID(id, 2); //获取下级项目
    },
    getProOne() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.user +
        "contract/projectListByLevel";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          level: 1
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proListOne = res.data.data;
            // console.log(this.proList);
          }
        });
    },
    getProID(id, level) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.user +
        "Contract/projectListByProjectId";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: id
        })
        .then(res => {
          if (res.data.code == 200) {
            if (level == 1) {
              this.proListTwo = res.data.data;
            } else if (level == 2) {
              this.proListThree = res.data.data;
            }
            // console.log(this.proList);
          }
        });
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proListThree = res.data.data;
            //  console.log(this.proList);
          }
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    on_return() {
      if (window.event.keyCode == 13) {
        this.getData();
      }
    },
    handleSizeChange(e) {
      this.size = e.target.value;
    },
    onChangeDate(date, dateString) {
      this.searchDate = dateString;
      // console.log(this.searchDate);
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    onSearch() {
      this.page = 1;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "Project/countNew";
      let pro = "";
      if (this.selectedThreeVal != "") {
        pro = this.selectedThreeVal;
      } else if (this.selectedTwoVal != "") {
        pro = this.selectedTwoVal;
      } else if (this.selectedOneVal != "") {
        pro = this.selectedOneVal;
      }
      let params = {
        current_page: this.page,
        per_page: 10,
        query_field: this.query_field,
        token: window.localStorage.getItem("xnwfPcToken"),
        start_date: this.searchDate[0],
        end_date: this.searchDate[1],
        trade_id: this.trade_id,
        department_id: this.department_id,
        role_ids: JSON.stringify(this.role_ids),
        project_id: pro
      };
      if (this.searchDate == "") {
        delete params.start_date;
        delete params.end_date;
      }
      axios
        .post(url, params)
        .then(res => {
          //   console.log(res);
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            this.count_data = res.data.data.count_data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    detailPage(val) {
      // this.$router.push({name:"resumeDetails"})
      this.details = val;
      this.isHideDetails = true;
    },
    onReset() {
      this.searchDate = "";
      this.query_field = "";
      this.trade_id = "";
      this.department_id = "";
      this.role_ids = [];
      this.date = undefined;
      this.selectedOneVal = "";
      this.selectedTwoVal = "";
      this.selectedThreeVal = "";
      this.proListTwo = [];
      this.proListThree = [];
      this.isShowTwo = false;
      this.page = 1;
      this.getData();
      this.getPro();
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  .ruzhiTJ {
    display: inline-block;
    li {
      display: inline-block;
      margin-right: 10px;
    }
  }

  .searchBox {
    padding: 14px 2%;
    display: block;
    > span {
      display: inline-block;
      margin-right: 30px;
      margin-bottom: 16px;
      line-height: 32px;
      > div {
        display: inline-block;
        vertical-align: top;
      }
      label {
        line-height: 32px;
      }
      > button {
        margin-left: 10px;
      }
    }
  }
}
</style>
<style lang="less">
.listContainer {
  // .ant-radio-button-wrapper-checked {
  //   border: 1px solid #d9d9d9;
  // }
  // .ant-radio-button-wrapper-checked::before {
  //   opacity: 0;
  //   background-color: #d9d9d9!important;
  // }
  // .ant-radio-button-wrapper-checked{
  //   box-shadow: unset;
  // }

  .addStyle {
    label:frist-child {
      box-shadow: -1px 0 0 0 #1890ff;
    }
  }
}
</style>
